'use client';

import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

export const AccessDeviceFeeAutoComplete = ({ id, handleChange, feeOptions, selectedFee, disabled, error }) => (
	<Autocomplete
		options={feeOptions}
		value={selectedFee?.id ? selectedFee : ''}
		freeSolo
		disabled={disabled}
		size='medium'
		isOptionEqualToValue={(option, value) => {
			if (typeof option === 'string' || typeof value === 'string') return false;
			return option?.id === value?.id;
		}}
		getOptionLabel={(option) => {
			if (typeof option === 'string') return '';
			return option.feeName;
		}}
		renderOption={(props, option) => {
			if (!option || typeof option === 'string') return null;
			return (
				<li {...props} key={`${id}-${option.id}`}>
					{option.feeName}
				</li>
			);
		}}
		renderInput={(params) => (
			<TextField
				{...params}
				value={selectedFee?.id || ''}
				inputProps={{ ...params.inputProps, 'data-cy': id }}
				error={error}
			/>
		)}
		onChange={handleChange}
	/>
);
